import { memo, useCallback, useMemo } from "react";

import { Button } from "ui/components/Button/Button";
import { Dropdown } from "ui/components/Dropdown/Dropdown";
import { DropdownOption } from "ui/components/Dropdown/Dropdown/types";

import { TenantSelectorProps } from "./types";

/**
 * Filtar po klijentu — odabir pretvara pregled platforme u pregled jednog klijenta.
 *
 * Koristi generički `Dropdown`, ne domenski `TenantDropdown`: taj u administraciju nije
 * kopiran, a klijente ionako već imamo učitane pa ih ne treba dohvaćati drugi put.
 */
const TenantSelector: React.FC<TenantSelectorProps> = (props) => {
  const { value, tenants, onSelect, onOpenDetail } = props;

  const options: DropdownOption[] = useMemo(
    () => [
      { value: "", text: "Svi klijenti" },
      ...tenants.map((tenant) => ({ value: tenant.tenantId, text: tenant.name })),
    ],
    [tenants]
  );

  const handleChange = useCallback(
    (_event: any, _name: string, item: DropdownOption) => {
      onSelect(item?.value ? String(item.value) : null);
    },
    [onSelect]
  );

  const handleClear = useCallback(() => {
    onSelect(null);
  }, [onSelect]);

  return (
    <div className="flex items-end gap-2">
      <div className="w-[280px]">
        <Dropdown
          name="platformTenant"
          label="Klijent"
          placeholder="Svi klijenti"
          value={value ?? ""}
          width="full"
          options={options}
          onChange={handleChange}
        />
      </div>

      {value && (
        <>
          <Button variant="outlined" children="Detalj" onClick={onOpenDetail} />
          <Button variant="text" children="Poništi" onClick={handleClear} />
        </>
      )}
    </div>
  );
};

export default memo(TenantSelector);
